class Constants {
  static SUBMISSION_NOTE = "The submission is in the review phase. You’ll receive an update as soon as a decision has been reached.";
  static UNDER_REVIEW = "Under Committee Review";
  static NEW_ARCHITECTURAL_FEATURE_ID = 55
}

export default Constants;